const ms = {
  nav: {
    features: 'Ciri-ciri',
    pricing: 'Harga',
    signIn: 'Log Masuk',
    getStarted: 'Mula Sekarang',
    home: 'Laman Utama',
    dashboard: 'Papan Pemuka',
    quotations: 'Sebut Harga',
    invoices: 'Invois',
    receipts: 'Resit',
    bills: 'Bil',
    documents: 'Semua Dokumen',
    docGroup: 'Dokumen',
    newDoc: 'Baharu',
    support: 'Sokongan',
    supportCases: 'Kes Sokongan',
    clients: 'Pelanggan',
    items: 'Item',
    settings: 'Tetapan',
    subscription: 'Langganan',
    profile: 'Profil',
    admin: 'Pentadbir',
    system: 'Sistem',
    users: 'Pengguna',
    userStats: 'Statistik Pengguna',
    finance: 'Kewangan',
    activity: 'Log Aktiviti',
    backups: 'Sandaran',
    changelog: 'Sejarah Versi',
    signOut: 'Log Keluar',
    viewProfile: 'Lihat profil',
    collapse: 'Runtuh',
    light: 'Cerah',
    dark: 'Gelap',
    full: 'Penuh',
    exit: 'Keluar',
    recurring: 'Berulang',
  },
  hero: {
    eyebrow: 'Pengurusan Dokumen Perniagaan',
    headline1: 'Sebut harga, invois',
    headline2: 'dan resit.',
    headline3: 'Dilakukan dengan betul.',
    sub: 'Berhenti bergelut dengan templat Word dan hamparan. Invio menyediakan PDF berjenama, pengurusan pelanggan, sokongan pelbagai mata wang dan percubaan percuma 30 hari.',
    ctaPrimary: 'Mulakan percubaan percuma 30 hari →',
    ctaSecondary: 'Lihat harga',
    trust: '✓ Tiada kad kredit diperlukan  ·  ✓ Batal bila-bila masa  ·  ✓ Sediakan dalam 60 saat',
  },
  stats: {
    docTypes: 'Jenis dokumen',
    currencies: 'Mata wang disokong',
    languages: 'Bahasa',
    docsPerMo: 'Dokumen sebulan',
    dayTrial: 'Hari percubaan percuma',
  },
  features: {
    eyebrow: 'Ciri-ciri',
    title: 'Semua yang anda perlukan untuk mengebil pelanggan',
    sub: 'Satu alat untuk setiap dokumen perniagaan — tanpa tambahan, tanpa upselling.',
    items: {
      quotations:    { title: 'Sebut Harga',          desc: 'Hantar cadangan profesional dan tukarkan kepada invois dengan satu klik.' },
      invoices:      { title: 'Invois',                desc: 'Bil pelanggan dengan PDF bernombor automatik dan berjenama dalam beberapa saat.' },
      receipts:      { title: 'Resit',                 desc: 'Keluarkan resit pembayaran yang sepadan dengan invois anda.' },
      bills:         { title: 'Bil Pembekal',          desc: 'Jejaki bil pembekal bersama-sama caj kepada pelanggan.' },
      purchase:      { title: 'Pesanan & Penghantaran',desc: 'Pesanan pembelian dan penghantaran untuk barang yang dipesan atau dihantar.' },
      credit:        { title: 'Nota Kredit',           desc: 'Keluarkan bayaran balik dan pelarasan dengan rekod lengkap.' },
      clients:       { title: 'Buku Alamat Pelanggan', desc: 'Rekod pelanggan boleh guna semula yang mengisi setiap dokumen secara automatik.' },
      multiCurrency: { title: 'Pelbagai Mata Wang',    desc: '{count} mata wang termasuk USD, EUR, MYR, CNY dan semua negara Liga Arab.' },
      export:        { title: 'Eksport PDF & Word',    desc: 'PDF sedia cetak dan .docx boleh diedit untuk setiap jenis dokumen.' },
    },
  },
  pricing: {
    eyebrow: 'Harga',
    title: 'Harga ringkas dan telus',
    sub: 'Mulakan dengan percubaan percuma 30 hari. Tiada kad kredit diperlukan.',
    monthly: 'Bulanan',
    yearly: 'Tahunan',
    perMonth: '/bulan',
    perYear: '/tahun',
    save: 'Jimat {p}%',
    cta: 'Mulakan percubaan percuma',
    custom: 'Tersuai',
    customPrice: 'Hubungi kami',
    customSub: 'Disesuaikan untuk pasukan anda',
    contactUs: 'Hubungi Kami',
    plan: {
      monthly: { f1: 'Dokumen tanpa had', f2: 'Pengekstrakan item AI', f3: 'Eksport PDF & Word', f4: 'Batal bila-bila masa' },
      yearly:  { f1: 'Bersamaan {amount}/bulan', f2: 'Dokumen tanpa had', f3: 'Pengekstrakan item AI', f4: 'Eksport PDF & Word' },
      custom:  { f1: 'Ciri & integrasi tersuai', f2: 'Diskaun jumlah besar', f3: 'Sokongan keutamaan', f4: 'Akaun pasukan berbilang pengguna' },
    },
  },
  finalCta: {
    title: 'Sedia untuk hantar invois pertama anda?',
    sub: 'Sediakan profil syarikat anda dalam 60 saat. Keluarkan sebut harga pertama anda hari ini.',
    button: 'Mula percuma →',
  },
  footer: {
    tagline: 'Pengurusan dokumen perniagaan profesional untuk pasukan kecil.',
    product: 'Produk',
    account: 'Akaun',
    contact: 'Hubungi Kami',
    createAccount: 'Cipta akaun',
    legal: 'Undang-undang',
    terms: 'Terma Perkhidmatan',
    privacy: 'Dasar Privasi',
    refund: 'Dasar Bayaran Balik',
    copyright: '© {year} Invio · invio.my',
  },
  banner: {
    verifyEmail: '⚠ Sahkan e-mel anda.',
    weSentLink: 'Kami telah menghantar pautan pengesahan ke',
    resend: 'Hantar semula e-mel',
    sending: 'Menghantar…',
    deactivated: 'Akaun anda telah dinyahaktifkan. Sila hubungi pentadbir.',
    trialEnded: 'Percubaan anda telah tamat',
    graceDaysLeft: 'anda mempunyai {d} hari tempoh ihsan lagi. Langgan untuk terus menggunakan Invio.',
    subscribeNow: 'Langgan sekarang',
    paymentFailed: 'Pembayaran gagal',
    paymentFailedMsg: 'kami tidak dapat mengecaj kad anda. Kemas kini kaedah pembayaran dalam {d} hari untuk kekal mendapat akses.',
    updatePayment: 'Kemas kini kaedah pembayaran',
    trialExtended: 'Percubaan anda telah dilanjutkan',
    trialExtendedBy: 'kami menambah {d} hari lagi. Percubaan anda kini berakhir pada {date}.',
    dismiss: 'Tutup',
  },
  emailPrefs: {
    title: 'Pemberitahuan e-mel',
    subtitle: 'Pilih e-mel pilihan yang kami hantar kepada anda.',
    securityAlerts: 'Amaran log masuk baharu',
    securityAlertsDesc: 'E-mel saya apabila akaun saya dilog masuk dari peranti atau pelayar baharu.',
    announcements: 'Kemas kini produk',
    announcementsDesc: 'Berita sesekali tentang ciri dan penambahbaikan Invio yang baharu.',
    transactionalNote: 'E-mel penting — pengesahan, tetapan semula kata laluan, kod keselamatan, pengebilan dan notis percubaan — sentiasa dihantar.',
  },
  sessions: {
    title: 'Sesi aktif',
    subtitle: 'Peranti yang log masuk ke akaun anda — log keluar mana-mana yang anda tidak kenali.',
    activeDevices: 'Peranti log masuk',
    none: 'Tiada sesi aktif lain.',
    thisDevice: 'Peranti ini',
    lastActive: 'Aktif terakhir {when}',
    revoke: 'Log keluar',
    signOutOthers: 'Log keluar daripada semua peranti lain',
    now: 'sebentar tadi',
    minAgo: '{n} min lalu',
    hrAgo: '{n} j lalu',
  },
  twofa: {
    title: 'Pengesahan dua langkah',
    enterAppCode: 'Masukkan kod 6 digit daripada aplikasi pengesah anda.',
    enterEmailCode: 'Kami telah menghantar kod 6 digit melalui e-mel. Masukkan di bawah.',
    trustDevice: "Jangan tanya lagi pada peranti ini selama 30 hari",
    verify: 'Sahkan',
    resend: 'Hantar semula kod',
    codeSent: 'Kod dihantar ✓',
    section: 'Pengesahan dua faktor (2FA)',
    sectionSub: 'Langkah kedua semasa log masuk melindungi akaun anda walaupun kata laluan bocor.',
    statusOff: 'Dimatikan',
    statusApp: 'Aktif — aplikasi pengesah',
    statusEmail: 'Aktif — kod e-mel',
    useApp: 'Guna aplikasi pengesah',
    useEmail: 'Guna kod e-mel',
    scanQr: 'Imbas kod QR ini dengan Google Authenticator, Microsoft Authenticator, Authy atau mana-mana aplikasi TOTP.',
    manualKey: 'Atau masukkan kunci ini secara manual:',
    thenEnter: 'Kemudian masukkan kod 6 digit yang dipaparkan aplikasi:',
    activate: 'Aktifkan',
    emailSent: 'Kami telah menghantar kod 6 digit ke {email}. Masukkannya untuk mengaktifkan kod e-mel.',
    enabled: 'Pengesahan dua faktor diaktifkan',
    disabled: 'Pengesahan dua faktor dimatikan',
    activeApp: 'Log masuk memerlukan kod daripada aplikasi pengesah anda.',
    activeEmail: 'Log masuk memerlukan kod yang dihantar ke e-mel anda.',
    turnOff: 'Matikan',
    confirmPassword: 'Masukkan kata laluan anda untuk mematikan pengesahan dua faktor:',
  },
  auth: {
    signInTab: 'Log Masuk',
    registerTab: 'Daftar',
    welcomeBack: 'Selamat kembali',
    createAccountTitle: 'Cipta akaun anda',
    signInSub: 'Log masuk untuk menguruskan dokumen perniagaan anda.',
    registerSub: 'Mulakan dengan Invio hari ini.',
    fullName: 'Nama Penuh',
    fullNamePlaceholder: 'Nama anda',
    email: 'Alamat E-mel',
    emailPlaceholder: 'you@example.com',
    password: 'Kata Laluan',
    passwordPlaceholder: '••••••••',
    rememberMe: 'Ingat saya',
    forgotPassword: 'Lupa kata laluan?',
    showPassword: 'Tunjuk kata laluan',
    hidePassword: 'Sembunyikan kata laluan',
    pleaseWait: 'Sila tunggu…',
    signInBtn: 'Log Masuk',
    createAccountBtn: 'Cipta Akaun',
    invalidCredentials: 'E-mel atau kata laluan tidak sah.',
    weakPassword: 'Kata laluan tidak memenuhi keperluan keselamatan.',
    backToSignIn: 'Kembali ke log masuk',
    resetTitle: 'Tetapkan semula kata laluan anda',
    resetIntro: 'Masukkan alamat e-mel yang dikaitkan dengan akaun anda dan kami akan menghantar pautan tetapan semula.',
    sendResetLink: 'Hantar Pautan Tetapan Semula',
    checkInbox: 'Periksa peti masuk anda',
    ifRegistered: 'Jika {email} didaftarkan, pautan tetapan semula kata laluan telah dihantar.',
    backToSignInBtn: 'Kembali ke Log Masuk',
    resetSendFailed: 'Pautan tetapan semula tidak dapat dihantar. Sila cuba lagi.',
    resetSpamHint: 'Pautan ini tamat tempoh dalam 1 jam. Jika e-mel tidak tiba dalam beberapa minit, semak folder spam anda.',
    agree: 'Dengan mencipta akaun, anda bersetuju dengan {terms} dan {privacy} kami.',
    tagline: 'Pengurusan dokumen perniagaan profesional — sebut harga, invois, resit dan banyak lagi.',
    feature1: 'Sebut Harga & Invois',
    feature2: 'Pengurusan Pelanggan',
    feature3: 'Eksport PDF & Word',
  },
  docType: {
    quotation: 'Sebut Harga', invoice: 'Invois', bill: 'Bil', receipt: 'Resit',
    purchase_order: 'Pesanan Belian', delivery_order: 'Pesanan Penghantaran',
    credit_note: 'Nota Kredit', statement: 'Penyata',
  },
  status: {
    draft: 'Draf', sent: 'Dihantar', accepted: 'Diterima', rejected: 'Ditolak',
    paid: 'Dibayar', overdue: 'Tertunggak', cancelled: 'Dibatalkan',
    partial: 'Dibayar sebahagian',
  },
  doc: {
    description: 'Keterangan', qty: 'Kti', unitPrice: 'Harga Seunit', amount: 'Jumlah',
    subtotal: 'Subjumlah', discount: 'Diskaun', tax: 'Cukai', total: 'JUMLAH',
  },
  docs: {
    allDocuments: 'Semua Dokumen',
    titlePlural: {
      quotation: 'Sebut Harga', invoice: 'Invois', bill: 'Bil', receipt: 'Resit',
      purchase_order: 'Pesanan Belian', delivery_order: 'Pesanan Penghantaran',
      credit_note: 'Nota Kredit', statement: 'Penyata',
    },
    count: '{n} dokumen',
    document: 'Dokumen',
    newType: '{type} Baharu',
    searchPlaceholder: 'Cari mengikut nombor atau klien…',
    allTypes: 'Semua Jenis',
    allStatus: 'Semua Status',
    noneFound: 'Tiada {title} dijumpai',
    createFirst: 'Cipta {type} pertama anda',
    thType: 'Jenis', thNumber: 'Nombor', thClient: 'Klien', thDate: 'Tarikh',
    thAmount: 'Jumlah', thStatus: 'Status', thActions: 'Tindakan',
    view: 'Lihat', edit: 'Sunting', copy: 'Salin', del: 'Padam',
    confirmDelete: 'Padam dokumen ini?',
    duplicateFailed: 'Tidak dapat menduplikasi dokumen',
  },
  editor: {
    editTitle: 'Sunting {type}',
    newTitle: '{type} Baharu',
    saveChanges: 'Simpan Perubahan',
    createDocument: 'Cipta Dokumen',
    documentDetails: 'Butiran Dokumen',
    documentType: 'Jenis Dokumen',
    status: 'Status',
    issueDate: 'Tarikh Keluaran',
    validUntil: 'Sah Sehingga',
    dueDate: 'Tarikh Akhir',
    referenceNumber: 'Nombor Rujukan',
    auto: 'Auto',
    manual: 'Manual',
    autoGenerated: 'Akan dijana secara automatik (cth. QT-2026-0001)',
    supplierBillTo: 'Pembekal & Bil Kepada',
    client: 'Klien',
    supplierName: 'Nama Pembekal',
    supplierNamePh: 'Nama syarikat pembekal',
    supplierAddress: 'Alamat Pembekal',
    supplierAddressPh: 'Alamat pembekal',
    billToClient: 'Bil Kepada (Klien)',
    selectClientPh: 'Pilih klien…',
    selectClient: 'Pilih Klien',
    noClient: '— Tiada klien —',
    addClient: '+ Tambah Klien',
    items: 'Item',
    titleOptional: 'Tajuk (pilihan)',
    titlePh: 'cth. Projek ABC – Fasa 1',
    hidePrices: 'Sembunyikan harga pada pesanan penghantaran ini',
    hidePricesHint: 'Membuang lajur Harga Seunit dan Jumlah serta semua jumlah keseluruhan daripada fail PDF dan Word. Harga yang dimasukkan kekal disimpan; nyahtanda untuk memaparkannya semula.',
    itemDescriptionPh: 'Keterangan item',
    saveAsItem: 'Simpan sebagai item guna semula',
    removeRow: 'Buang baris',
    addItem: '+ Tambah Item',
    fromSaved: 'Dari simpanan',
    notesTerms: 'Nota & Terma',
    notesLabel: 'Nota (dilihat oleh klien)',
    notesPh: 'Terima kasih atas sokongan anda…',
    termsLabel: 'Terma & Syarat',
    termsPh: 'Terma pembayaran, syarat penghantaran…',
    includeSignature: 'Sertakan blok tandatangan dalam PDF',
    currencyPricing: 'Mata Wang & Harga',
    currency: 'Mata Wang',
    taxRatePct: 'Kadar Cukai (%)',
    discountType: 'Jenis Diskaun',
    fixed: 'Tetap',
    percent: 'Peratus',
    discountValue: 'Nilai Diskaun',
    summary: 'Ringkasan',
    pricesHiddenEditorNote: 'Harga disembunyikan pada pesanan penghantaran ini — angka di bawah disimpan tetapi tidak akan dipaparkan dalam fail PDF atau Word.',
    generating: 'Menjana…',
    previewPdf: 'Pratonton / Cetak PDF',
    downloadWord: 'Muat Turun Word (.docx)',
    pickSavedItem: 'Pilih item tersimpan',
    noSavedItems: 'Tiada item tersimpan lagi.',
    manageItems: 'Urus Item',
    searchItemsPh: 'Cari item…',
    itemNeedsDescription: 'Item {n} memerlukan keterangan',
    docUpdated: 'Dokumen dikemas kini!',
    docCreated: 'Dokumen dicipta!',
    errorSaving: 'Ralat semasa menyimpan',
    pdfFailed: 'Tidak dapat menjana PDF',
    wordFailed: 'Tidak dapat menjana fail Word',
    addDescriptionFirst: 'Tambah keterangan dahulu',
    savedToLibrary: 'Disimpan ke pustaka Item',
    couldNotSaveItem: 'Tidak dapat menyimpan item',
  },
  docView: {
    back: 'Kembali',
    issuedOn: 'Dikeluarkan {date}',
    statusUpdated: 'Status dikemas kini kepada {s}',
    converted: 'Ditukar kepada {t}!',
    duplicated: 'Dokumen diduplikasi!',
    deleteConfirm: 'Padam dokumen ini secara kekal?',
    notFound: 'Dokumen tidak dijumpai.',
    from: 'Daripada',
    supplier: 'Pembekal',
    billedTo: 'Dibilkan Kepada',
    updateStatus: 'Kemas Kini Status',
    dates: 'Tarikh',
    linkedDocument: 'Dokumen Berkaitan',
    paymentDetails: 'Butiran Pembayaran',
    bank: 'Bank',
    account: 'Akaun',
    name: 'Nama',
    notes: 'Nota',
    terms: 'Terma & Syarat',
    pricesHiddenView: 'Harga disembunyikan pada pesanan penghantaran ini.',
    convertDocument: 'Tukar Dokumen',
    convertIntro: 'Tukar {n} kepada jenis dokumen baharu. Dokumen asal akan ditanda sebagai diterima.',
    convertTo: 'Tukar Kepada',
    convert: 'Tukar',
    duplicate: 'Duplikasi',
  },
  clients: {
    title: 'Klien',
    count: '{n} klien',
    addClient: 'Tambah Klien',
    empty: 'Tiada klien lagi. Tambah klien pertama anda untuk bermula.',
    editClient: 'Edit Klien',
    fullName: 'Nama Penuh *',
    company: 'Syarikat',
    email: 'E-mel',
    phone: 'Telefon',
    address: 'Alamat',
    city: 'Bandar',
    notes: 'Nota',
    notesPh: 'Sebarang nota tentang klien ini…',
    updated: 'Klien dikemas kini!',
    added: 'Klien ditambah!',
    deleted: 'Klien dipadam',
    confirmDelete: 'Padam klien ini?',
  },
  items: {
    title: 'Item',
    count: '{n} item disimpan',
    importBtn: 'Import daripada Dokumen',
    addItem: 'Tambah Item',
    searchPh: 'Cari mengikut keterangan, SKU, pembekal, jenama, kategori…',
    empty: 'Tiada item disimpan lagi. Tambah produk atau perkhidmatan boleh guna semula untuk mempercepat penyediaan dokumen.',
    noMatch: 'Tiada item sepadan dengan "{q}".',
    unitPrice: 'Harga seunit',
    unit: 'Unit',
    inStock: 'Dalam stok',
    supplier: 'Pembekal',
    editItem: 'Edit Item',
    description: 'Keterangan *',
    descriptionPh: 'Pakej reka bentuk laman web',
    unitPriceLabel: 'Harga Seunit ({s})',
    costPriceLabel: 'Harga Kos ({s})',
    taxRate: 'Kadar Cukai (%)',
    unitLabel: 'Unit',
    unitPh: 'jam, unit, hari…',
    category: 'Kategori',
    categoryPh: 'Perkhidmatan, Produk…',
    stockQty: 'Kuantiti Stok',
    sku: 'SKU',
    skuPh: 'Kod produk',
    barcode: 'Kod Bar',
    barcodePh: 'UPC / EAN',
    brand: 'Jenama',
    notes: 'Nota',
    notesPh: 'Sebarang nota dalaman tentang item ini…',
    updated: 'Item dikemas kini!',
    added: 'Item ditambah!',
    deleted: 'Item dipadam',
    confirmDelete: 'Padam item ini?',
    errorSaving: 'Ralat semasa menyimpan',
    aiPaidOnly: 'Import AI tersedia pada pelan berbayar. Naik taraf di halaman Langganan untuk menggunakannya.',
    importTitle: 'Import Item daripada Dokumen',
    importIntro: 'Muat naik fail PDF, imej, Excel (.xlsx/.xls) atau CSV. AI OCR kami akan mengekstrak item, kemudian anda boleh semak dan edit sebelum menyimpan.',
    takePhoto: 'Ambil gambar',
    noneDetected: 'Tiada item dikesan dalam dokumen ini.',
    extractionFailed: 'Pengekstrakan gagal.',
    cameraFailed: 'Kamera gagal.',
    foundSelected: '{n} item ditemui · {c} dipilih',
    selectAll: 'Pilih semua',
    clear: 'Kosongkan',
    thDescription: 'Keterangan', thUnitPrice: 'Harga Seunit', thCost: 'Kos', thUnit: 'Unit',
    thSku: 'SKU', thCategory: 'Kategori', thBrand: 'Jenama', thSupplier: 'Pembekal',
    thTax: 'Cukai %', thQty: 'Kuantiti',
    working: 'Sedang diproses…',
    saveCount: 'Simpan {n} item',
    selectAtLeastOne: 'Pilih sekurang-kurangnya satu item',
    imported: '{n} item diimport',
    importFailed: 'Import gagal',
  },
  profile: {
    title: 'Profil Saya',
    subtitle: 'Urus butiran akaun dan keselamatan anda',
    accountInfo: 'Maklumat Akaun',
    accountInfoSub: 'Kemas kini nama dan alamat e-mel anda',
    emailChangeHint: 'Untuk keselamatan anda, menukar e-mel memerlukan kata laluan. Kami akan menghantar pautan pengesahan ke alamat baharu — e-mel semasa anda kekal berfungsi sehingga anda mengesahkan.',
    emailNeedsPassword: 'Masukkan kata laluan semasa anda untuk menukar e-mel.',
    sendConfirmation: 'Hantar pengesahan',
    emailConfirmSent: 'Pengesahan dihantar ke {email}. Klik pautan di sana untuk menyelesaikan perubahan — e-mel semasa anda masih berfungsi sehingga itu.',
    emailPending: 'Perubahan kepada {email} sedang menunggu — semak peti masuk itu untuk pautan pengesahan.',
    cancelEmailChange: 'Batalkan penukaran e-mel',
    emailChangeCancelled: 'Penukaran e-mel dibatalkan',
    uploadPhoto: 'Muat naik foto',
    changePhoto: 'Tukar foto',
    removePhoto: 'Buang',
    photoUpdated: 'Foto profil dikemas kini',
    photoRemoved: 'Foto profil dibuang',
    photoTooLarge: 'Imej terlalu besar. Sila guna yang bawah 1 MB.',
    fullName: 'Nama Penuh',
    fullNamePh: 'Nama anda',
    email: 'Alamat E-mel',
    updated: 'Profil dikemas kini!',
    updateFailed: 'Gagal mengemas kini profil',
    changePassword: 'Tukar Kata Laluan',
    changePasswordSub: 'Gunakan kata laluan kukuh dengan sekurang-kurangnya 6 aksara',
    currentPassword: 'Kata Laluan Semasa',
    newPassword: 'Kata Laluan Baharu',
    confirmPassword: 'Sahkan Kata Laluan Baharu',
    noMatch: 'Kata laluan tidak sepadan',
    weakPassword: 'Kata laluan baharu tidak memenuhi keperluan keselamatan.',
    changed: 'Kata laluan berjaya ditukar!',
    changeFailed: 'Gagal menukar kata laluan',
    updating: 'Mengemas kini…',
    updatePassword: 'Kemas Kini Kata Laluan',
    session: 'Sesi',
    sessionSub: 'Urus sesi log masuk aktif anda',
    signedInAs: 'Log masuk sebagai',
    thisDevice: 'Peranti ini',
    memberSince: 'Ahli sejak',
    protected: 'Aktif',
    signOutOf: 'Log keluar daripada Invio',
    redirected: 'Anda akan dibawa ke halaman log masuk.',
    accountType: 'Jenis Akaun',
    standard: 'Standard',
    plan: 'Pelan',
    comingSoon: 'Akan Datang',
    photoUpload: 'Muat naik foto profil',
    twoFactor: 'Pengesahan dua faktor',
    emailNotifications: 'Pemberitahuan e-mel',
    sessionMgmt: 'Pengurusan sesi aktif',
  },
  settings: {
    title: 'Tetapan',
    subtitle: 'Konfigurasi profil syarikat dan tetapan lalai dokumen anda',
    saveSettings: 'Simpan Tetapan',
    saved: 'Tetapan disimpan!',
    companyLogo: 'Logo Syarikat',
    preview: 'Pratonton',
    uploadImage: 'Muat Naik Imej',
    removeWhiteBg: 'Buang latar belakang putih',
    remove: 'Buang',
    logoHeight: 'Tinggi Logo (px)',
    previewNote: 'Pratonton dipaparkan pada latar gelap seperti pengepala PDF.',
    whiteBgRemoved: 'Latar belakang putih dibuang — jangan lupa simpan',
    logoProcessFailed: 'Tidak dapat memproses imej logo',
    companyInfo: 'Maklumat Syarikat',
    companyName: 'Nama Syarikat *',
    address: 'Alamat',
    cityState: 'Bandar / Negeri',
    phone: 'Telefon',
    email: 'E-mel',
    website: 'Laman Web',
    regNo: 'No. Pendaftaran',
    taxNo: 'No. Cukai / SST',
    docAppearance: 'Rupa Dokumen',
    docAppearanceIntro: 'Digunakan pada setiap dokumen yang anda jana, dalam PDF dan fail Word.',
    templateGallery: 'Templat PDF',
    templateGalleryHint: 'Pilih gaya visual untuk dokumen PDF anda. Muat turun Word sentiasa menggunakan susun atur Klasik.',
    tplClassic: 'Klasik',
    tplMinimal: 'Minimal',
    tplBold: 'Tebal',
    tplElegant: 'Elegan',
    tplGradient: 'Gradien',
    tplSlate: 'Arang',
    tplSoft: 'Lembut',
    tplStripe: 'Jalur',
    tplFrame: 'Bingkai',
    tplMono: 'Mono',
    tplSidebar: 'Bar Sisi',
    tplLedger: 'Lejar',
    tplSlim: 'Nipis',
    tplCurve: 'Lengkung',
    tplDiagonal: 'Serong',
    tplBanner: 'Sepanduk',
    tplDuo: 'Duo',
    tplCards: 'Kad',
    tplPop: 'Pop',
    tplRoyal: 'Diraja',
    tplMarker: 'Penanda',
    tplSketch: 'Lakaran',
    tplGhost: 'Garis Luar',
    tplMidnight: 'Tengah Malam',
    colorPresets: 'Pratetap Warna',
    colorPresetsHint: 'Pasangan warna satu klik, digunakan pada mana-mana templat yang anda pilih — laraskan dengan pemilih di bawah.',
    presetNavy: 'Biru Tua',
    presetSky: 'Biru Langit',
    presetTeal: 'Teal',
    presetEmerald: 'Zamrud',
    presetBurgundy: 'Burgundi',
    presetCrimson: 'Merah Tua',
    presetCopper: 'Tembaga',
    presetPlum: 'Plum',
    presetRose: 'Mawar',
    presetGraphite: 'Grafit',
    headerColour: 'Warna Pengepala',
    accentColour: 'Warna Aksen',
    hexInvalid: 'Perlu hex 6 digit seperti #1A3C6E — nilai lalai akan digunakan.',
    font: 'Fon',
    bodySize: 'Saiz Teks Badan (px)',
    headerSizePct: 'Saiz Pengepala (%)',
    headerTextSizes: 'Saiz Teks Pengepala (px) — setiap kotak teks dalam pengepala secara berasingan',
    hCompanyName: 'Nama Syarikat',
    hTagline: 'Laman Web / Slogan',
    hContact: 'Maklumat Hubungan',
    hDocTitle: 'Tajuk Dokumen',
    hMeta: 'Baris No. / Tarikh',
    compactHeader: 'Pengepala padat',
    compactHeaderHint: ' — alihkan maklumat hubungan ke bawah laman web, di sebelah logo, untuk menjimatkan ruang menegak',
    partySection: 'Bahagian Disediakan Untuk / Dikeluarkan Oleh',
    partyLabels: 'Label (px)',
    partyNames: 'Nama (px)',
    partyDetails: 'Butiran (px)',
    headerGap: 'Ruang Selepas Pengepala (px)',
    headerGapHint: 'Ruang Selepas Pengepala mengawal jarak antara jalur pengepala dan bahagian ini (0 = bersentuhan).',
    resetTheme: 'Set semula kepada tema lalai',
    currencyDefaults: 'Mata Wang & Lalai',
    defaultCurrency: 'Mata Wang Lalai',
    pdfMargin: 'Jidar PDF / Word (cm)',
    defaultTerms: 'Terma & Syarat Lalai',
    termsPh: 'cth. Bayaran perlu dijelaskan dalam tempoh 30 hari. Caj lewat 1.5% sebulan dikenakan pada akaun tertunggak…',
    bankDetails: 'Butiran Bank / Pembayaran',
    bankDetailsIntro: 'Butiran ini akan dipaparkan pada semua invois dan resit secara automatik.',
    bankName: 'Nama Bank',
    accountNumber: 'Nombor Akaun',
    accountHolder: 'Nama Pemegang Akaun',
    signatory: 'Penandatangan Sah',
    signatoryName: 'Nama',
    designation: 'Jawatan',
    signatureImage: 'Imej Tandatangan Digital',
    noSignature: 'Tiada tandatangan',
    removeSignature: 'Buang tandatangan',
    pngRecommended: 'PNG dengan latar belakang lutsinar disyorkan.',
    saveAll: 'Simpan Semua Tetapan',
    errorSaving: 'Ralat semasa menyimpan',
  },
  subscription: {
    title: 'Langganan',
    subtitle: 'Urus pelan Invio dan pengebilan anda',
    currentPlan: 'Pelan Semasa',
    freeTrial: 'Percubaan Percuma',
    none: 'Tiada',
    trialEndsIn: 'Percubaan tamat dalam',
    days: '{d} hari',
    renewsOn: 'Diperbaharui pada',
    billingHistory: 'Sejarah Bil',
    subscribedSince: 'Melanggan sejak',
    totalPaid: 'Jumlah dibayar',
    payDate: 'Tarikh',
    payAmount: 'Amaun',
    payPlan: 'Pelan',
    payStatus: 'Status',
    payReceipt: 'Resit',
    paySucceeded: 'Dibayar',
    payFailed: 'Gagal',
    pastDueMsg: 'Pembayaran gagal. Sila kemas kini kaedah pembayaran anda untuk terus menggunakan Invio.',
    manageBilling: 'Urus Pengebilan →',
    opening: 'Membuka…',
    portalUnavailable: 'Portal tidak tersedia',
    activated: 'Langganan diaktifkan! Memuat semula…',
    checkoutCancelled: 'Pembayaran dibatalkan',
    readyToContinue: 'Bersedia untuk meneruskan dengan Invio?',
    getInTouch: 'Hubungi kami',
    tailorPlan: 'Kami akan sesuaikan pelan mengikut perniagaan anda. Hubungi kami dan kami akan bantu anda bermula.',
    talkToUs: 'Hubungi Kami',
    whatsapp: 'WhatsApp',
    choosePlan: 'Pilih pelan',
    upgradeAnytime: 'Naik taraf bila-bila masa',
    subscribeMonthly: 'Langgan Bulanan',
    subscribeYearly: 'Langgan Tahunan',
    redirecting: 'Mengalihkan…',
    checkoutFailed: 'Pembayaran gagal. Sila cuba lagi.',
    securePayment: 'Pembayaran selamat melalui Stripe. Batal bila-bila masa.',
    needCustom: 'Perlukan pelan tersuai?',
  },
  password: {
    length: 'Sekurang-kurangnya 8 aksara',
    lowercase: 'Satu huruf kecil',
    uppercase: 'Satu huruf besar',
    digit: 'Satu nombor',
    symbol: 'Satu simbol (cth. ! @ # $ %)',
    common: 'Bukan kata laluan yang biasa digunakan',
    weak: 'Lemah',
    fair: 'Sederhana',
    strong: 'Kukuh',
    excellent: 'Cemerlang',
    meetsAll: 'Memenuhi semua keperluan',
  },
  server: {
    emailRegistered: 'E-mel sudah didaftarkan',
    invalidCredentials: 'E-mel atau kata laluan tidak sah',
    accountDeactivated: 'Akaun anda telah dinyahaktifkan. Hubungi pentadbir.',
    missingToken: 'Token pengesahan tiada',
    verifyInvalid: 'Pautan pengesahan tidak sah atau telah digunakan',
    verifyExpired: 'Pautan pengesahan telah tamat tempoh. Sila minta yang baharu.',
    emailRequired: 'E-mel diperlukan',
    resetInvalid: 'Pautan tetapan semula kata laluan ini tidak sah atau telah digunakan.',
    resetExpired: 'Pautan tetapan semula kata laluan ini telah tamat tempoh. Sila minta yang baharu.',
    tooManyRequests: 'Terlalu banyak percubaan. Sila tunggu beberapa minit dan cuba lagi.',
    currentPasswordRequired: 'Kata laluan semasa diperlukan',
    currentPasswordWrong: 'Kata laluan semasa tidak betul',
    weakPassword: 'Kata laluan tidak memenuhi keperluan keselamatan.',
    aiPaidOnly: 'Ciri AI memerlukan langganan berbayar. Naik taraf untuk menggunakan import AI.',
    missingFileData: 'Data fail tiada.',
    fileTooLarge: 'Fail melebihi had 25 MB.',
    itemNotFound: 'Item tidak ditemui',
    clientNotFound: 'Klien tidak ditemui',
    docNotFound: 'Dokumen tidak ditemui',
    noStripeCustomer: 'Belum ada akaun pengebilan dipautkan. Sila langgan dahulu.',
    alreadySubscribed: 'Anda sudah mempunyai langganan. Gunakan Urus Pengebilan untuk mengubahnya.',
    supportFieldsRequired: 'Subjek dan mesej diperlukan',
    caseNotFound: 'Kes tidak ditemui',
    caseClosed: 'Kes ini telah ditutup. Sila buka kes baharu.',
    caseReopenExpired: 'Kes ini tidak boleh dibuka semula. Sila buka kes baharu.',
    paymentNotPayable: 'Pembayaran hanya boleh direkodkan pada invois dan bil.',
    paymentCancelledDoc: 'Dokumen ini telah dibatalkan.',
    paymentInvalidAmount: 'Masukkan jumlah pembayaran lebih daripada sifar.',
    paymentExceedsBalance: 'Pembayaran melebihi baki yang perlu dibayar.',
    paymentInvalidDate: 'Tarikh pembayaran tidak sah.',
    paymentNotFound: 'Pembayaran tidak dijumpai.',
    statusPaidByPayments: 'Dokumen ini telah dibayar penuh. Buang pembayaran untuk menukar statusnya.',
    shareNotFound: 'Pautan ini tidak lagi tersedia.',
    shareCannotRespond: 'Sebut harga ini tidak lagi boleh dibalas.',
    shareBadAction: 'Pilih terima atau tolak.',
    shareNameRequired: 'Sila masukkan nama anda.',
    sendNotConfigured: 'Penghantaran e-mel belum disediakan pada pelayan ini.',
    sendVerifyFirst: 'Sahkan alamat e-mel anda sendiri sebelum menghantar dokumen.',
    sendNoRecipient: 'Masukkan alamat e-mel penerima.',
    sendTooManyRecipients: 'Maksimum 5 alamat bagi setiap medan.',
    sendBadRecipient: 'Salah satu alamat e-mel tidak sah.',
    sendDailyLimit: 'Had e-mel harian dicapai. Cuba lagi esok.',
    sendFailed: 'Tidak dapat menghantar e-mel.',
    recurringBadFrequency: 'Kekerapan tidak diketahui.',
    recurringNoStart: 'Pilih tarikh invois pertama.',
    recurringEndBeforeStart: 'Tarikh tamat adalah sebelum invois pertama.',
    recurringNotInvoice: 'Hanya invois boleh diulang.',
    recurringNotFound: 'Jadual tidak dijumpai.',
    einvoiceLocked: 'Dokumen ini ialah e-Invois LHDN yang telah dihantar dan tidak boleh diubah lagi. Batalkan e-Invois (dalam 72 jam) atau keluarkan nota kredit.',
    einvDisabled: 'e-Invois belum dihidupkan.',
    einvNoCredentials: 'Client ID dan secret MyInvois belum ditetapkan.',
    einvBadCredentials: 'MyInvois menolak client ID / secret. Semak semula bersama persekitaran.',
    einvUnreachable: 'Tidak dapat menghubungi MyInvois. Sila cuba lagi.',
    einvNotReady: 'Beberapa butiran belum lengkap.',
    einvAlreadySubmitted: 'Dokumen ini telah dihantar kepada LHDN.',
    einvSubmitFailed: 'MyInvois tidak menerima penghantaran.',
    einvRejected: 'MyInvois menolak dokumen.',
    einvNotValid: 'Hanya e-Invois yang disahkan boleh dibatalkan.',
    einvCancelReason: 'Berikan sebab pembatalan.',
    einvCancelWindow: 'Tempoh pembatalan 72 jam telah tamat — keluarkan nota kredit.',
    einvCancelFailed: 'MyInvois tidak membatalkan dokumen.',
    einvApiError: 'MyInvois memulangkan ralat. Sila cuba lagi.',
  },
  reset: {
    checking: 'Menyemak pautan tetapan semula anda…',
    title: 'Pilih kata laluan baharu',
    intro: 'Masukkan kata laluan baharu untuk akaun Invio anda.',
    newPassword: 'Kata Laluan Baharu',
    confirmPassword: 'Sahkan Kata Laluan Baharu',
    mismatch: 'Kedua-dua kata laluan tidak sepadan.',
    submit: 'Tetapkan Semula Kata Laluan',
    failedGeneric: 'Kata laluan anda tidak dapat ditetapkan semula. Sila cuba lagi.',
    success: 'Kata laluan dikemas kini',
    successBody: 'Anda kini boleh log masuk dengan kata laluan baharu anda. Peranti lain telah dilog keluar.',
    invalidTitle: 'Pautan tetapan semula tidak sah',
    invalidGeneric: 'Pautan tetapan semula kata laluan ini tidak sah atau telah tamat tempoh.',
    requestNew: 'Minta Pautan Baharu',
  },
  verify: {
    verifying: 'Mengesahkan e-mel anda…',
    justAMoment: 'Sebentar sahaja.',
    verified: 'E-mel disahkan',
    confirmed: 'telah disahkan. Anda kini boleh menggunakan Invio seperti biasa.',
    continue: 'Teruskan ke Invio →',
    failed: 'Pengesahan gagal',
    failedGeneric: 'Pautan pengesahan tidak sah atau telah tamat tempoh.',
    alreadySignedIn: 'Sudah log masuk? Anda boleh minta e-mel pengesahan baharu daripada sepanduk di bahagian atas mana-mana halaman.',
  },
  support: {
    title: 'Sokongan',
    subtitle: 'Buka kes dan kami akan menghubungi anda',
    newCase: 'Kes Baharu',
    empty: 'Tiada kes sokongan lagi. Ada masalah atau soalan? Buka kes dan kami akan bantu.',
    created: 'Kes {n} dibuka — kami akan menghubungi anda tidak lama lagi',
    createFailed: 'Tidak dapat membuka kes',
    subject: 'Subjek *',
    subjectPh: 'Ringkasan ringkas isu',
    category: 'Kategori',
    priority: 'Keutamaan',
    message: 'Terangkan isu *',
    messagePh: 'Apa yang berlaku? Apa yang anda jangkakan? Langkah untuk menghasilkan semula sangat membantu…',
    attachments: 'Tangkapan skrin (pilihan, sehingga 3 imej)',
    attachTooLarge: 'Imej terlalu besar (maks 2 MB)',
    submit: 'Buka Kes',
    yourTurn: 'Balasan diperlukan',
    allCases: 'Semua kes',
    cat: { billing: 'Pengebilan & langganan', bug: 'Pepijat / ada yang rosak', question: 'Soalan / cara guna', feature: 'Cadangan ciri', other: 'Lain-lain' },
    status: { open: 'Dibuka', in_progress: 'Dalam proses', waiting_on_user: 'Menunggu balasan anda', resolved: 'Selesai', closed: 'Ditutup' },
    prio: { low: 'Rendah', normal: 'Biasa', high: 'Tinggi' },
    resolvedTitle: 'Kes ini ditanda sebagai selesai',
    resolvedAsk: 'adakah masalah anda selesai?',
    confirmClose: 'Ya, tutup kes',
    reopen: 'Tidak, buka semula',
    you: 'Anda',
    supportTeam: 'Sokongan Invio',
    caseClosed: 'Kes ini telah ditutup. Perlukan bantuan lagi?',
    replyPh: 'Tulis balasan…',
    send: 'Hantar',
    sendFailed: 'Tidak dapat menghantar',
    closedMsg: 'Kes ditutup — terima kasih!',
    reopenedMsg: 'Kes dibuka semula — kami akan semak sekali lagi',
  },
  notif: {
    title: 'Pemberitahuan',
    empty: 'Tiada pemberitahuan lagi',
    justNow: 'sebentar tadi',
    minutesAgo: '{n} minit lalu',
    hoursAgo: '{n} jam lalu',
    daysAgo: '{n} hari lalu',
    trialExtended: 'Percubaan anda dilanjutkan sebanyak {days} hari. 🎉',
    trialReminder: 'Percubaan anda tamat dalam {days} hari. Langgan untuk kekalkan akses.',
    trialGrace: 'Percubaan anda telah tamat — tinggal {days} hari tempoh tangguh sebelum akaun dikunci.',
    paymentFailed: 'Pembayaran gagal — kemas kini kaedah pembayaran dalam {days} hari untuk kekalkan akses.',
    paymentRecovered: 'Pembayaran berjaya dipulihkan — langganan anda aktif semula.',
    paymentReceipt: 'Pembayaran diterima: {amount} — terima kasih! Resit telah diemelkan kepada anda.',
    supportReply: 'Pihak sokongan membalas kes anda {n}.',
    supportResolved: 'Kes sokongan anda {n} telah selesai.',
    supportCase: 'Kes sokongan baharu {n} daripada {from}.',
    supportUserReply: '{from} membalas kes sokongan {n}.',
    docViewed: '{client} telah membuka {n}',
    quoteAccepted: '{client} menerima sebut harga {n}',
    quoteRejected: '{client} menolak sebut harga {n}',
    recurringIssued: 'Invois berulang {n} dikeluarkan untuk {client}',
    recurringIssuedSent: 'Invois berulang {n} dikeluarkan dan die-mel kepada {client}',
    recurringIssuedError: 'Invois berulang {n} dikeluarkan, tetapi tidak die-mel: {error}',
    invoiceOverdue: 'Invois {n} kini tertunggak',
    invoicesOverdue: '{count} invois telah tertunggak',
    einvoiceValid: 'LHDN mengesahkan e-Invois {n}',
    einvoiceInvalid: 'LHDN menolak e-Invois {n} — buka untuk lihat sebabnya',
  },
  impersonate: {
    banner: 'Sesi sokongan pentadbir',
    return: 'Kembali ke pentadbir',
  },
  payments: {
    title: 'Pembayaran',
    record: 'Rekod pembayaran',
    none: 'Belum ada pembayaran direkodkan.',
    paid: 'Jumlah dibayar',
    balance: 'Baki perlu dibayar',
    balanceShort: 'Baki {amount}',
    amount: 'Jumlah',
    date: 'Tarikh pembayaran',
    method: 'Kaedah',
    reference: 'No. rujukan',
    referencePh: 'cth. rujukan pindahan bank',
    note: 'Nota',
    notePh: 'cth. deposit 30%',
    payFull: 'Baki penuh',
    save: 'Simpan pembayaran',
    recorded: 'Pembayaran direkodkan',
    removed: 'Pembayaran dibuang',
    confirmRemove: 'Buang pembayaran ini?',
    failed: 'Tidak dapat menyimpan pembayaran',
    fullyPaid: 'Dibayar penuh',
    m_bank_transfer: 'Pindahan bank',
    m_cash: 'Tunai',
    m_card: 'Kad',
    m_cheque: 'Cek',
    m_ewallet: 'E-dompet',
    m_online: 'Pembayaran dalam talian',
    m_other: 'Lain-lain',
  },
  statement: {
    title: 'Penyata Akaun',
    button: 'Penyata',
    back: 'Pelanggan',
    from: 'Dari',
    to: 'Hingga',
    currency: 'Mata wang',
    thisMonth: 'Bulan ini',
    lastMonth: 'Bulan lepas',
    thisYear: 'Tahun ini',
    downloadPdf: 'Muat turun PDF',
    opening: 'Baki awal',
    closing: 'Baki akhir',
    invoiced: 'Diinvois',
    paid: 'Dibayar',
    credited: 'Dikreditkan',
    paidCredit: 'Dibayar / Kredit',
    balanceDue: 'Baki perlu dibayar',
    balance: 'Baki',
    date: 'Tarikh',
    details: 'Butiran',
    k_invoice: 'Invois',
    k_payment: 'Pembayaran diterima',
    k_credit_note: 'Nota kredit',
    due: 'Perlu dibayar {date}',
    empty: 'Tiada transaksi dalam tempoh ini.',
    aging: 'Tertunggak mengikut usia',
    current: 'Semasa',
    days: '{range} hari',
    loadFailed: 'Tidak dapat memuatkan penyata',
  },
  share: {
    send: 'Hantar',
    title: 'Hantar {n}',
    cardTitle: 'Perkongsian',
    linkTitle: 'Pautan awam',
    linkHelp: 'Sesiapa yang mempunyai pautan ini boleh melihat dokumen dan memuat turun PDF. Tidak perlu log masuk.',
    createLink: 'Cipta pautan',
    copy: 'Salin',
    copied: 'Pautan disalin',
    open: 'Buka',
    disable: 'Matikan pautan',
    disableConfirm: 'Matikan pautan ini? Sesiapa yang sudah memilikinya tidak akan dapat membukanya lagi.',
    disabled: 'Pautan dimatikan',
    whatsapp: 'Kongsi di WhatsApp',
    whatsappText: 'Hai {name}, berikut ialah {type} {n} daripada {company}:\n{url}',
    emailTitle: 'E-mel kepada pelanggan',
    to: 'Kepada',
    cc: 'Sk (pilihan)',
    ccPh: 'akaun@pelanggan.com, anda@syarikat.com',
    subject: 'Subjek',
    message: 'Mesej',
    defaultSubject: '{type} {n} daripada {company}',
    defaultMessage: 'Hai {name},\n\nDilampirkan {type} {n} untuk rujukan anda.\n\nTerima kasih,\n{sender}',
    attachPdf: 'Lampirkan PDF',
    includeLink: 'Sertakan butang "lihat dalam talian"',
    replyNote: 'Dihantar atas nama syarikat anda. Balasan akan pergi ke {email}.',
    sendEmail: 'Hantar e-mel',
    sending: 'Menghantar…',
    sent: 'E-mel dihantar kepada {to}',
    sendFailed: 'Tidak dapat menghantar e-mel',
    linkFailed: 'Tidak dapat mencipta pautan',
    linkOn: 'Pautan awam aktif',
    linkOff: 'Belum dikongsi',
    views: 'Dilihat {n} kali',
    notViewed: 'Belum dilihat',
    lastViewed: 'Kali terakhir dilihat {date}',
    lastEmailed: 'Die-mel kepada {to} pada {date}',
    responded_accepted: 'Diterima oleh {name} pada {date}',
    responded_rejected: 'Ditolak oleh {name} pada {date}',
    reminderSubject: 'Peringatan: {type} {n} daripada {company}',
    reminderMessage: 'Hai {name},\n\nIni peringatan mesra bahawa {type} {n} masih belum dibayar. Mungkin ia terlepas pandang.\n\nJika anda telah membuat pembayaran, sila abaikan mesej ini — terima kasih.\n\nSalam hormat,\n{sender}',
  },
  publicDoc: {
    loading: 'Memuatkan dokumen…',
    notFoundTitle: 'Pautan ini tidak lagi tersedia',
    notFoundBody: 'Pengirim mungkin telah mematikannya. Sila minta pautan baharu daripada mereka.',
    from: 'Daripada',
    to: 'Kepada',
    issued: 'Dikeluarkan',
    due: 'Perlu dibayar',
    validUntil: 'Sah sehingga',
    downloadPdf: 'Muat turun PDF',
    preparing: 'Menyediakan…',
    pdfFailed: 'Tidak dapat menyediakan PDF. Sila cuba lagi.',
    amountDue: 'Jumlah perlu dibayar',
    paidInFull: 'Telah dibayar penuh — terima kasih!',
    howToPay: 'Cara pembayaran',
    acceptTitle: 'Balas sebut harga ini',
    yourName: 'Nama penuh anda',
    accept: 'Terima sebut harga',
    decline: 'Tolak',
    declineConfirm: 'Tolak sebut harga ini?',
    acceptNote: 'Dengan menerima, anda mengesahkan item, harga dan terma yang ditunjukkan di atas.',
    accepted: 'Diterima oleh {name} pada {date}',
    rejected: 'Ditolak oleh {name} pada {date}',
    respondFailed: 'Tidak dapat menyimpan respons anda. Sila cuba lagi.',
    poweredBy: 'Dihantar dengan Invio — cipta invois anda sendiri percuma selama 30 hari',
    regNo: 'No. pendaftaran',
    taxNo: 'No. cukai',
  },
  recurring: {
    title: 'Invois Berulang',
    subtitle: 'Invois yang dikeluarkan secara automatik mengikut jadual',
    empty: 'Belum ada invois berulang. Buka mana-mana invois dan pilih “Jadikan berulang”.',
    goInvoices: 'Pergi ke invois',
    make: 'Jadikan berulang',
    modalTitle: 'Ulang {n}',
    modalIntro: 'Invio akan mengeluarkan invois baharu dengan item yang sama mengikut jadual ini. Invois ini sendiri tidak diubah.',
    frequency: 'Ulang',
    every: 'Setiap',
    f_weekly: 'minggu',
    f_monthly: 'bulan',
    f_quarterly: 'suku tahun',
    f_yearly: 'tahun',
    firstInvoice: 'Invois pertama pada',
    endDate: 'Tarikh tamat (pilihan)',
    dueDays: 'Bayaran perlu dibuat selepas (hari)',
    autoSend: 'E-mel setiap invois kepada pelanggan secara automatik',
    autoSendHelp: 'Mati: invois dicipta sebagai draf untuk anda semak dan hantar.',
    noClientEmail: 'Pelanggan ini tiada alamat e-mel — tambah satu untuk guna hantar automatik.',
    create: 'Mulakan jadual',
    created: 'Invois berulang disediakan. Seterusnya: {date}',
    saved: 'Jadual dikemas kini',
    failed: 'Tidak dapat menyimpan jadual',
    thClient: 'Pelanggan / invois',
    thAmount: 'Jumlah',
    thSchedule: 'Jadual',
    thNext: 'Invois seterusnya',
    thStatus: 'Status',
    summary: 'Setiap {n} {unit}',
    issued: '{n} dikeluarkan',
    last: 'Terakhir: {n}',
    until: 'sehingga {date}',
    autoSendOn: 'Hantar automatik',
    asDraft: 'Cipta draf',
    s_active: 'Aktif',
    s_paused: 'Dijeda',
    s_ended: 'Tamat',
    pause: 'Jeda',
    resume: 'Sambung',
    runNow: 'Keluarkan sekarang',
    runConfirm: 'Keluarkan invois seterusnya sekarang?',
    ran: '{n} dikeluarkan',
    deleteConfirm: 'Padam jadual ini? Invois yang telah dikeluarkan akan dikekalkan.',
    deleted: 'Jadual dipadam',
    lastError: 'Larian terakhir: {msg}',
    fromSchedule: 'Dikeluarkan oleh jadual berulang',
    basedOn: 'Berdasarkan {n}',
  },
  reminders: {
    title: 'Peringatan pembayaran',
    intro: 'Invio boleh menghantar e-mel kepada pelanggan anda secara automatik apabila invois hampir atau telah melepasi tarikh akhir. E-mel dihantar atas nama syarikat anda dengan pautan ke invois; balasan datang kepada anda. Invois sentiasa ditandakan tertunggak secara automatik, sama ada peringatan dihidupkan atau tidak.',
    enable: 'Hantar peringatan pembayaran kepada pelanggan secara automatik',
    before: 'Hari sebelum tarikh akhir (0 = mati)',
    after: 'Hari selepas tarikh akhir',
    afterHelp: 'Dipisahkan dengan koma, cth. 1, 7, 14',
    needsEmail: 'Hanya invois yang pelanggannya mempunyai alamat e-mel akan menerima peringatan. Anda boleh mengecualikan satu invois dari halamannya.',
    docToggle: 'Tiada peringatan automatik untuk invois ini',
    docSent: 'Peringatan dihantar: {n}',
    updated: 'Pilihan peringatan disimpan',
  },
  onboarding: {
    title: 'Mulakan dengan Invio',
    subtitle: 'Empat langkah ringkas ke invois pertama anda dengan logo anda sendiri.',
    progress: '{done} daripada {total} selesai',
    dismiss: 'Sembunyikan',
    s_company: 'Tambah butiran syarikat anda',
    d_company: 'Nama dan logo anda muncul pada setiap dokumen.',
    s_client: 'Tambah pelanggan pertama anda',
    d_client: 'Simpan butiran mereka sekali, guna semula pada setiap sebut harga dan invois.',
    s_document: 'Cipta invois atau sebut harga pertama anda',
    d_document: 'Pilih pelanggan, tambah item, siap. Eksport ke PDF atau Word bila-bila masa.',
    s_sent: 'Hantar kepada pelanggan anda',
    d_sent: 'Melalui e-mel dengan PDF dilampirkan, di WhatsApp, atau sebagai pautan — dan lihat bila mereka membukanya.',
    companyName: 'Nama syarikat',
    phone: 'Telefon',
    logo: 'Logo (pilihan)',
    saveCompany: 'Simpan',
    moreSettings: 'Tetapan lain',
    companySaved: 'Butiran syarikat disimpan',
    addClient: 'Tambah pelanggan',
    newInvoice: 'Invois baharu',
    newQuotation: 'Sebut harga baharu',
    openDocs: 'Buka dokumen saya',
    sampleTitle: 'Hanya mahu lihat rupanya?',
    sampleBody: 'Cipta invois contoh dengan satu klik dan buka sebagai PDF dengan penjenamaan anda. Ia kekal sebagai draf — padam bila-bila masa.',
    sampleCreate: 'Cipta invois contoh',
    sampleOpen: 'Buka invois contoh',
    sampleFailed: 'Tidak dapat mencipta contoh',
    sampleBanner: 'Ini ialah invois contoh. Cuba butang PDF dan Hantar, kemudian padamkannya — ia draf dan tidak menjejaskan angka anda.',
  },
  einv: {
    title: 'e-Invois LHDN (MyInvois)',
    subtitle: 'Hantar invois dan nota kredit kepada LHDN untuk pengesahan, terus dari Invio',
    back: 'Tetapan',
    settingsIntro: 'Malaysia mewajibkan e-Invois secara berperingkat. Sambungkan akaun MyInvois anda dan Invio akan menghantar invois anda kepada LHDN serta meletakkan kod QR pengesahan pada PDF.',
    open: 'Sediakan e-Invois',
    statusOn: 'Aktif — {env}',
    statusOff: 'Belum disediakan',
    stepsTitle: 'Cara menyambung',
    step1: 'Log masuk ke portal MyInvois (mulakan dengan sandbox: preprod.myinvois.hasil.gov.my).',
    step2: 'Buka profil pembayar cukai anda → Representatives → Register ERP. Namakannya “Invio”.',
    step3: 'Salin Client ID dan Client Secret yang dipaparkan (secret hanya dipaparkan sekali) dan tampal di bawah.',
    step4: 'Uji sambungan, hantar invois ujian dalam sandbox, kemudian tukar ke Production dengan kunci production anda.',
    enable: 'Gunakan e-Invois LHDN',
    connection: 'Sambungan MyInvois',
    environment: 'Persekitaran',
    sandbox: 'Sandbox (ujian)',
    production: 'Production (e-Invois sebenar)',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    secretSaved: 'Disimpan — biarkan kosong untuk kekalkan',
    secretNote: 'Disimpan secara tersulit. Ia tidak akan dipaparkan lagi atau dihantar semula ke pelayar anda.',
    test: 'Uji sambungan',
    testing: 'Menguji…',
    testOk: 'Disambungkan ke MyInvois ({env}).',
    testTinValid: 'TIN dan nombor pendaftaran anda sepadan dengan rekod LHDN.',
    testTinInvalid: 'Disambungkan, tetapi LHDN tidak mengenali gabungan TIN + nombor pendaftaran ini.',
    saveFirst: 'Simpan tetapan anda dahulu, kemudian uji.',
    supplier: 'Butiran cukai anda',
    supplierNote: 'Nama syarikat, alamat, bandar dan e-mel diambil daripada Tetapan utama anda.',
    tin: 'TIN (Nombor Pengenalan Cukai)',
    idType: 'Jenis ID',
    id_BRN: 'No. pendaftaran perniagaan (BRN)',
    id_NRIC: 'MyKad / NRIC',
    id_PASSPORT: 'Pasport',
    id_ARMY: 'ID Tentera',
    idValue: 'No. ID / pendaftaran',
    sstNo: 'No. pendaftaran SST (jika berdaftar)',
    ttxNo: 'No. cukai pelancongan (jika ada)',
    msic: 'Kod MSIC (5 digit)',
    msicHelp: 'Cari kod anda dalam profil portal MyInvois atau senarai MSIC LHDN.',
    activity: 'Keterangan aktiviti perniagaan',
    postcode: 'Poskod',
    state: 'Negeri',
    chooseState: 'Pilih negeri…',
    phone: 'Nombor telefon',
    defaults: 'Lalai untuk setiap e-Invois',
    classification: 'Klasifikasi jualan anda',
    classificationHelp: '“022 Others” sesuai untuk kebanyakan perniagaan. Anda boleh menukarnya bagi setiap invois semasa menghantar.',
    taxType: 'Cukai yang anda kenakan (apabila invois mempunyai cukai)',
    taxNone: 'Saya tidak mengenakan cukai',
    tax_01: 'Cukai Jualan',
    tax_02: 'Cukai Perkhidmatan',
    save: 'Simpan tetapan e-Invois',
    saved: 'Tetapan e-Invois disimpan',
    versionNote: 'Invio menghantar dokumen versi 1.0, yang diterima LHDN tanpa sijil digital. Versi 1.1 (ditandatangani secara digital) akan menyusul apabila LHDN menamatkan 1.0.',
    clientSection: 'Butiran e-Invois (LHDN)',
    clientSectionHelp: 'Hanya diperlukan jika anda menghantar e-Invois untuk pelanggan ini.',
    buyerTin: 'TIN pelanggan',
    generalPublic: 'Tiada TIN — individu Malaysia',
    generalForeign: 'Tiada TIN — pembeli asing',
    country: 'Negara (kod 3 huruf)',
    checkTin: 'Semak dengan LHDN',
    tinValid: 'LHDN mengenali TIN dan ID ini.',
    tinInvalid: 'LHDN tidak mengenali gabungan TIN + ID ini.',
    card: 'e-Invois LHDN',
    st_none: 'Belum dihantar',
    st_submitted: 'Dihantar — menunggu LHDN',
    st_valid: 'Disahkan oleh LHDN',
    st_invalid: 'Ditolak oleh LHDN',
    st_cancelled: 'e-Invois dibatalkan',
    submit: 'Hantar kepada LHDN',
    resubmit: 'Betulkan dan hantar semula',
    submitting: 'Menghantar…',
    refresh: 'Semak status',
    viewOnPortal: 'Lihat di MyInvois',
    uuid: 'UUID',
    validatedOn: 'Disahkan {date}',
    sandboxBadge: 'Sandbox',
    locked: 'Dokumen ini dikunci: apa yang disahkan LHDN mesti kekal sama seperti yang dipegang pelanggan anda. Untuk mengubahnya, batalkan e-Invois (dalam 72 jam) atau keluarkan nota kredit.',
    modalTitle: 'Hantar {n} kepada LHDN',
    modalIntro: 'LHDN mengesahkan e-Invois dalam beberapa saat. Setelah disahkan, dokumen dikunci dan PDF memaparkan kod QR LHDN.',
    sandboxWarning: 'Mod sandbox: ini penghantaran ujian dan tiada kesan undang-undang.',
    productionWarning: 'Production: ini e-Invois sebenar yang dilaporkan kepada LHDN.',
    fixFirst: 'Betulkan ini dahulu:',
    fixInSettings: 'Tetapan e-Invois',
    fixInClient: 'Sunting pelanggan',
    exchangeRate: 'Kadar pertukaran: 1 {cur} = ? MYR',
    notEnabled: 'e-Invois belum disediakan.',
    done_valid: 'Disahkan oleh LHDN ✓',
    done_submitted: 'Dihantar. LHDN masih mengesahkan — semak status sebentar lagi.',
    done_invalid: 'LHDN menolak e-Invois — lihat sebabnya pada dokumen.',
    failed: 'Tidak dapat menghantar kepada LHDN',
    cancel: 'Batalkan e-Invois',
    cancelTitle: 'Batalkan e-Invois LHDN',
    cancelIntro: 'LHDN membenarkan pembatalan dalam tempoh 72 jam selepas pengesahan. Selepas itu, keluarkan nota kredit. Pelanggan anda dimaklumkan oleh LHDN.',
    cancelReason: 'Sebab',
    cancelReasonPh: 'cth. Jumlah salah',
    cancelled: 'e-Invois dibatalkan',
    publicBadge: 'e-Invois LHDN yang disahkan',
    publicVerify: 'Sahkan di MyInvois',
  },
  einvP: {
    einvType: 'Hanya invois dan nota kredit boleh dihantar sebagai e-Invois.',
    einvCancelledDoc: 'Dokumen ini telah dibatalkan.',
    einvNoItems: 'Dokumen tiada item.',
    einvItemDescription: 'Setiap item memerlukan keterangan.',
    einvSupplierTin: 'TIN anda tiada atau tidak sah.',
    einvSupplierId: 'Nombor pendaftaran perniagaan / ID anda tiada.',
    einvMsic: 'Kod MSIC 5 digit anda tiada.',
    einvActivity: 'Keterangan aktiviti perniagaan anda tiada.',
    einvSupplierName: 'Nama syarikat anda tiada (Tetapan).',
    einvSupplierAddress: 'Alamat syarikat anda tiada (Tetapan).',
    einvSupplierCity: 'Bandar syarikat anda tiada (Tetapan).',
    einvSupplierState: 'Pilih negeri anda.',
    einvSupplierPhone: 'Nombor telefon anda tiada.',
    einvNoClient: 'Pautkan dokumen ini kepada pelanggan.',
    einvBuyerTin: 'TIN pelanggan tiada (gunakan TIN umum untuk pembeli tanpa TIN).',
    einvBuyerId: 'Nombor pendaftaran / ID pelanggan tiada.',
    einvBuyerAddress: 'Alamat pelanggan tiada.',
    einvBuyerCity: 'Bandar pelanggan tiada.',
    einvBuyerState: 'Pilih negeri pelanggan.',
    einvBuyerCountry: 'Negara pelanggan mestilah kod 3 huruf (cth. MYS).',
    einvBuyerPhone: 'Nombor telefon pelanggan tiada.',
    einvExchangeRate: 'Masukkan kadar pertukaran kepada MYR.',
    einvTaxType: 'Pilih sama ada cukai anda ialah Cukai Jualan atau Cukai Perkhidmatan.',
    einvSstNo: 'Nombor pendaftaran SST anda diperlukan apabila anda mengenakan cukai.',
    einvOriginal: 'Nota kredit mesti dicipta daripada invois yang telah menjadi e-Invois yang disahkan.',
  },
  common: {
    save: 'Simpan',
    saving: 'Menyimpan…',
    cancel: 'Batal',
    edit: 'Edit',
    delete: 'Padam',
    view: 'Lihat',
    loading: 'Memuatkan…',
    welcome: 'Selamat hari',
    overview: 'Berikut ialah gambaran perniagaan anda',
    language: 'Bahasa',
  },
};
export default ms;
